import { render } from "./lsbs_packets.vue?vue&type=template&id=2c186a29"
import script from "./lsbs_packets.vue?vue&type=script&lang=js"
export * from "./lsbs_packets.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__